/**
 * Auctions module
 *
 * Module index file
 *
 * This file is used by theme to provide default functionality
 * to the module and to register all components.
 *
 * This file has to export setup function that will be called
 * automatically by import in the theme app.ts file.
 */

import { App } from 'vue';

import AuctionCurrentBlock from '@src/Auctions/Pages/Blocks/AuctionCurrentBlock.vue';
import AuctionFutureBlock from '@src/Auctions/Pages/Blocks/AuctionFutureBlock.vue';
import AuctionPastBlock from '@src/Auctions/Pages/Blocks/AuctionPastBlock.vue';

export const setup = (app: App<Element>): void => {
    app.component('AuctionCurrentBlock', AuctionCurrentBlock);
    app.component('AuctionFutureBlock', AuctionFutureBlock);
    app.component('AuctionPastBlock', AuctionPastBlock);
};
